import { render, staticRenderFns } from "./UploadResult.vue?vue&type=template&id=30dee382&"
import script from "./UploadResult.vue?vue&type=script&lang=ts&"
export * from "./UploadResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports